import type { FC } from 'react';

import type { TIconProps } from './icon.props';

const IconDragHandle: FC<TIconProps> = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M6 5.06667C6.5891 5.06667 7.06667 4.5891 7.06667 4C7.06667 3.4109 6.5891 2.93333 6 2.93333C5.4109 2.93333 4.93333 3.4109 4.93333 4C4.93333 4.5891 5.4109 5.06667 6 5.06667Z"
    />
    <path
      d="M10 5.06667C10.5891 5.06667 11.0667 4.5891 11.0667 4C11.0667 3.4109 10.5891 2.93333 10 2.93333C9.4109 2.93333 8.93333 3.4109 8.93333 4C8.93333 4.5891 9.4109 5.06667 10 5.06667Z"
    />
    <path
      d="M6 9.06667C6.5891 9.06667 7.06667 8.5891 7.06667 8C7.06667 7.4109 6.5891 6.93333 6 6.93333C5.4109 6.93333 4.93333 7.4109 4.93333 8C4.93333 8.5891 5.4109 9.06667 6 9.06667Z"
    />
    <path
      d="M10 9.06667C10.5891 9.06667 11.0667 8.5891 11.0667 8C11.0667 7.4109 10.5891 6.93333 10 6.93333C9.4109 6.93333 8.93333 7.4109 8.93333 8C8.93333 8.5891 9.4109 9.06667 10 9.06667Z"
    />
    <path
      d="M6 13.0667C6.5891 13.0667 7.06667 12.5891 7.06667 12C7.06667 11.4109 6.5891 10.9333 6 10.9333C5.4109 10.9333 4.93333 11.4109 4.93333 12C4.93333 12.5891 5.4109 13.0667 6 13.0667Z"
    />
    <path
      d="M10 13.0667C10.5891 13.0667 11.0667 12.5891 11.0667 12C11.0667 11.4109 10.5891 10.9333 10 10.9333C9.4109 10.9333 8.93333 11.4109 8.93333 12C8.93333 12.5891 9.4109 13.0667 10 13.0667Z"
    />
  </svg>
);

export {
  IconDragHandle,
};
